import { ApplicationController } from "../../application_controller"
import moment from 'moment'

export default class extends ApplicationController {
    static targets = []

    initialize() {}

    /* ***** Helpers ***** */

    helperController() {
	var section_helper = $(this.element).closest(".section-helper")
	return this.application.getControllerForElementAndIdentifier(section_helper[0], 'layouts--section--section-helper')
    }
}
